export enum ACCOUNT_STATUS {
  CREATED = 'Created',
  PROFILED = 'Profiled',
  ACCEPTED_PROPOSAL = 'AcceptedProposal',
  WAITING_CONTRACT_SIGNATURE = 'WaitingContractSignature',
  SIGNED_CONTRACT = 'SignedContract',
  // WAITING_BANK_ACCOUNT_CREATION = 'WaitingBankAccountCreation',
  ACTIVE = 'Active',
  SUSPENDED = 'Suspended',
}

export const AccountStatuses = {
  Created: 0,
  Profiled: 1,
  AcceptedProposal: 2,
  WaitingContractSignature: 3,
  SignedContract: 4,
  // WaitingBankAccountCreation: 5,
  Active: 5,
};

export enum PORTFOLIO_STATUS {
  CREATED = 'Created',
  FINANCED = 'Financed',
  ON_TRACK = 'OnTrack',
  OFF_TRACK = 'OffTrack',
}

export const PortfolioStatuses = {
  Created: 0,
  Financed: 1,
  OnTrack: 2,
  OffTrack: 3,
};

export enum PORTFOLIO_PROPOSAL_STATUS {
  CREATED = 'Created',
  PUBLISHED = 'Published',
  ACCEPTED = 'Accepted',
}

export const PortfolioProposalStatuses = {
  Created: 0,
  Published: 1,
  Accepted: 2,
};

export enum INVESTMENT_OBJECTIVE_STATUS {
  CREATED = 'Created',
  EVALUATING = 'Evaluating',
  ACCEPTED = 'Accepted',
}

export const InvestmentObjectiveStatuses = {
  Created: 0,
  Evaluating: 1,
  Accepted: 2,
};

export enum USER_STATUS {
  LEAD = 'Lead',
  PROFILED = 'Profiled',
  VERIFIED = 'Verified',
  ACTIVE = 'Active',
  DELETED = 'Deleted',
}

export const UserStatuses = {
  Lead: 0,
  Profiled: 1,
  Verified: 2,
  Active: 3,
  Deleted: 4,
};

export enum LEAD_STATUS {
  NEW = 'New',
  IN_PROGRESS = 'InProgress',
  CONNECTED = 'Connected',
  UNQUALIFIED = 'Unqualified',
}

export const LeadStatuses = {
  New: 0,
  InProgress: 1,
  Connected: 2,
  Unqualified: 3,
};

export function getPortfolioProposalStatus(proposal: any) {
  if (proposal.accepted) return 'Accepted';
  if (proposal.published) return 'Published';
  return 'Created';
}
